export default function deselectNodes(nodes) {
  return nodes.map(node => node.isSelected ? ({
    ...node,
    isSelected: false,
  }) : node)
}
